import { useEffect, useState } from "react";
import { getDormantFeatures, subscribeDormantFeatures } from "./dormantFeatures.js";

export function useDormantFeatures() {
  const [features, setFeatures] = useState(getDormantFeatures);
  useEffect(() => subscribeDormantFeatures(setFeatures), []);
  return features;
}
